import React, { useContext } from "react";
import "./Projects.scss";
import { projects, socialMediaLinks } from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";
import Loading from "../loading/Loading";
import { Fade } from "react-reveal";

export default function Projects({ repos }) {
  const { isDark } = useContext(StyleContext);

  // Ensure repos is an array
  const reposArray = Array.isArray(repos) ? repos : [];

  if (!projects.display) {
    return null;
  }

  return (
    <section className={`section ${isDark ? "dark-mode" : ""}`} id="projects">
      <div className="container">
        <Fade bottom duration={1000} distance="20px">
          <p className="typography-eyebrow mb-2">My Work</p>
          <h2 className="typography-headline mb-3">Projects & Case Studies</h2>
          <p className="section-subtitle mb-5">
            A curated selection of impactful projects I've built, led, or contributed to—highlighting my skills in data, AI, and engineering.
          </p>
        </Fade>

      {/* Projects grid */}
      <div className="projects-grid-container">
        {reposArray.length === 0 ? (
          <div className="loading-spinner">
            <Loading />
          </div>
        ) : (
          <div className="projects-grid">
            {reposArray.map((repo, index) => (
              <Fade bottom duration={1000} distance="20px" delay={index * 100} key={index}>
                <a
                  href={repo.node.url}
                  className="project-card"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="project-content">
                    <div className="project-text">
                      <h3 className="project-title">
                        {repo.node.name
                          .replace(/-/g, ' ')
                          .replace(/with/gi, 'with')
                          .replace(/and/gi, '&')
                          .split(' ')
                          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                          .join(' ')}
                      </h3>
                      <p className="project-description">
                        {repo.node.description || "A GitHub repository by " + repo.node.owner.login}
                      </p>
                    </div>
                    <div className="project-image-container">
                      <img
                        src={`/images/${repo.node.name.toLowerCase().includes('neural') ? 'neuralnetwork' :
                               repo.node.name.toLowerCase().includes('air') ? 'airquality' :
                               repo.node.name.toLowerCase().includes('spotify') ? 'spotify' :
                               repo.node.name.toLowerCase().includes('pdf') ? 'pdfprocessor' :
                               repo.node.name.toLowerCase().includes('image') ? 'imageprocessor' :
                               repo.node.name.toLowerCase().includes('leetcode') ? 'leetcode150' :
                               'default-project'}.png`}
                        alt={`${repo.node.name} project screenshot`}
                        className="project-image"
                        loading="lazy"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = '/images/default-project.png';
                        }}
                      />
                    </div>
                  </div>
                  <div className="github-link">
                    <i className="fab fa-github"></i>
                  </div>
                </a>
              </Fade>
            ))}
          </div>
        )}
      </div>

      {/* View all projects button */}
      <div className="view-all-container">
        <Fade bottom duration={1000} distance="20px">
          <a
            className="view-all-button"
            href={socialMediaLinks.github}
            target="_blank"
            rel="noopener noreferrer"
          >
            View All Projects
          </a>
        </Fade>
      </div>
      </div>
    </section>
  );
}
